export default {"src":"/_next/static/media/vuejs_logo_9927255915.9b5adfa4.svg","height":160,"width":320,"blurWidth":0,"blurHeight":0};